import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { EppPortlet, Portlet, PortletRepo, registerInnerWidget, WidgetRepo } from '@gspwidget/util';
import { Property, PropertyTypes, Widget, WidgetBase } from '@gspwidget/widget-devkit';
import { forkJoin } from 'rxjs';


/**
 * name = id = code
 */
const SHELL_LAYOUT_WIDGET_CODE = 'shell-layout'

@Widget({
  name: SHELL_LAYOUT_WIDGET_CODE,
  enableCommonTitleBar: true,
})
@Component({
  selector: 'lib-shell-layout',
  templateUrl: './shell-layout.component.html',
  styleUrls: ['./shell-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShellLayoutComponent extends WidgetBase {

  @Property({
    type: PropertyTypes.Object,
    isArray: true,
    objectOption: {
      objPropertyOptions: [{
        name: 'portletId',
        type: PropertyTypes.Help2,
        help2Option: {
          preset: 'eppPortlet',
          valueField: 'id',
          labelField: 'name',
        },
      }, {
        name: 'width',
        textOption: { default: '50%' },
      }]
    }
  }) portletOpts: {
    portletId?: string
    width?: string
  }[]

  portlets: PortletWithFeOnly[]
  // portletMap: { [pid: string]: EppPortlet }
  // activePid: string

  constructor (
    public portletRepo: PortletRepo,
    public cd: ChangeDetectorRef,
  ) {
    super()
  }

  onPropertyChange (propName: string, value) {
    if (propName === 'portletOpts') {
      this.refreshPortletsByIds()
    }
  }

  ngOnInit () {
  }

  refreshPortletsByIds () {
    if (!this.portletOpts) {
      this.portlets = null
      return
    }
    // 过滤掉空值后的部件 id 列表
    const goodPlOpts = this.portletOpts.filter(opt => opt && opt.portletId)
    if (!goodPlOpts || !goodPlOpts[0]) {
      this.portlets = null
    }

    const getPortlets$ = goodPlOpts.map(opt => this.portletRepo.getPortletById(opt.portletId))
    forkJoin(getPortlets$).subscribe(pls => {
      this.portlets = pls
      this.portlets.forEach(pl => {
        pl.feOnly = { width: goodPlOpts.find(opt => opt.portletId === pl.id).width }
      })
      this.cd.markForCheck()
    })
  }

}

export interface PortletWithFeOnly extends Portlet {
  feOnly?: any
}

registerInnerWidget({
  widgetComponent: ShellLayoutComponent,
  baseUrl: '',
  id: SHELL_LAYOUT_WIDGET_CODE,
  name: SHELL_LAYOUT_WIDGET_CODE,
  version: '6',
  isDevMode: true,
})
